import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface IActionButtonProps extends ButtonProps {
    /**
     * Icon to display before the button text
     */
    icon?: React.ReactElement<Record<string, unknown>>;
}

/**
 * Reusable action button component with consistent styling
 * Used for primary and secondary actions in headers and toolbars
 */
export const ActionButton = ({
    icon,
    children,
    sx,
    ...props
}: IActionButtonProps) => {
    return (
        <Button
            variant="contained"
            startIcon={
                icon
                    ? React.cloneElement(icon, {
                          style: {
                              fontSize: "0.9rem !important",
                              width: "0.9rem",
                              height: "0.9rem",
                          },
                      })
                    : undefined
            }
            sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                padding: "5px 14px",
                borderRadius: "6px",
                "&.MuiButton-outlined": {
                    padding: "4px 13px",
                },
                boxShadow: "none",
                transition:
                    "background-color 0.15s ease, box-shadow 0.15s ease",
                "&:hover": {
                    boxShadow: "none",
                },
                "&[aria-disabled='true'], &[aria-disabled='true']:hover": {
                    color: "action.disabled",
                    cursor: "default",
                },
                "&.MuiButton-contained[aria-disabled='true'], &.MuiButton-contained[aria-disabled='true']:hover":
                    {
                        bgcolor: "action.disabledBackground",
                    },
                "& .MuiButton-startIcon": {
                    marginRight: "0.35rem",
                    "& > svg": {
                        fontSize: "0.9rem",
                    },
                },
                ...sx,
            }}
            {...props}
        >
            {children}
        </Button>
    );
};
